var QueryKey;
(function (QueryKey) {
  QueryKey["postCreateCollaborators"] = "postCreateCollaborators";
  QueryKey["putCollaborator"] = "putCollaborator";
  QueryKey["getMyAccess"] = "getMyAccess";
  QueryKey["getMyCollaborator"] = "getMyCollaborator";
  QueryKey["getMyCollaborators"] = "getMyCollaborators";
  QueryKey["postSignInRoleplay"] = "postSignInRoleplay";
  QueryKey["postSignOutRoleplay"] = "postSignOutRoleplay";
  QueryKey["getRoleplayReference"] = "getRoleplayReference";
  QueryKey["hasAccountsAccess"] = "hasAccountsAccess";
})(QueryKey || (QueryKey = {}));

export { QueryKey };
